/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { createElement, useState } from 'react'
import Transition from 'react-transition-group/Transition'

import { cx } from '@emotion/css'
import { colors } from '@offerzen/pinata-shame'
import MenuIcon from '@offerzen/zenicon/MenuIcon'
import AccessibleIcon from '../AccessibleIcon'
import NavigationLink from '../NavigationLink'
import { companyStateNavigation, navigationLinks } from '../../helpers/navigationHelpers'

import styles, { wrapperTransition, navTransition } from './styles'

/**
 *
 * @param {Object} props
 * @param {string} props.companySlug
 * @param {string} props.impersonatedHiringTeam
 * @param {string} props.companyState
 * @param {string} props.userRole
 * @param {function} props.signOut
 * @param {string} props.emailPreferencesAccessTokenKey
 * @param {number} props.unreadInterviewRequestCount
 */
const MobileNav = ({
  companySlug,
  impersonatedHiringTeam,
  companyState,
  userRole,
  signOut,
  emailPreferencesAccessTokenKey,
  unreadInterviewRequestCount,
}) => {
  const [open, setNavOpen] = useState(false)
  const stateNavigation = companyStateNavigation({ companyState })
  const { navItems, mobileAdminItems } = stateNavigation
  const mobileStateNavigationItems = { ...navItems, ...mobileAdminItems }
  const navLinkKeys = Object.keys(mobileStateNavigationItems).filter(navItem => mobileStateNavigationItems[navItem])

  const navigationLinkVariables = {
    companySlug,
    impersonatedHiringTeam,
    emailPreferencesAccessTokenKey,
    unreadInterviewRequestCount,
    companyState,
  }

  return (
    <>
      <button type="button" className={styles.menu} onClick={() => setNavOpen(true)}>
        <AccessibleIcon icon={MenuIcon} size={24} color={colors.white} />
        <span className={styles.accessiblyHidden}>Menu</span>
      </button>
      <Transition in={open} timeout={{ enter: 0, exit: 300 }} mountOnEnter unmountOnExit>
        {status => (
          <div className={cx(styles.wrapper, wrapperTransition(status))}>
            <div className={styles.overlay} onClick={() => setNavOpen(false)} />

            <ul className={cx(styles.nav, navTransition(status))}>
              <For each="navItem" of={navLinkKeys}>
                <With
                  restrictUserRole={navigationLinks(navigationLinkVariables)[navItem]?.restrictUserRole}
                  to={navigationLinks(navigationLinkVariables)[navItem]?.to}
                  href={navigationLinks(navigationLinkVariables)[navItem]?.href}
                  closeMobileNav={navigationLinks(navigationLinkVariables)[navItem]?.closeMobileNav}
                  isActive={navigationLinks(navigationLinkVariables)[navItem]?.isActive}
                  target={navigationLinks(navigationLinkVariables)[navItem]?.target}
                  icon={navigationLinks(navigationLinkVariables)[navItem]?.icon}
                  mobileLabel={navigationLinks(navigationLinkVariables)[navItem]?.mobileLabel}
                  label={navigationLinks(navigationLinkVariables)[navItem]?.label}
                  subItems={navigationLinks(navigationLinkVariables)[navItem]?.subItems}>
                  {/*
                    NavLinks
                  */}
                  <If condition={restrictUserRole !== userRole}>
                    <li key={navItem} className={styles.navItem}>
                      <Choose>
                        <When condition={navItem !== 'log_out'}>
                          <NavigationLink
                            className={styles.link}
                            activeClassName={subItems?.length ? styles.activeSubNav : styles.activeLink}
                            to={to}
                            href={href}
                            toggleNavbar={() => to && setNavOpen(false)}
                            isActive={isActive}
                            target={target}>
                            <If condition={!!icon}>
                              <AccessibleIcon icon={icon} className={styles.icon} size={18} color={colors.white} />
                            </If>
                            <Choose>
                              <When condition={!!mobileLabel}>{createElement(mobileLabel)}</When>
                              <Otherwise>
                                <span>{label}</span>
                              </Otherwise>
                            </Choose>
                          </NavigationLink>

                          <If condition={!!subItems}>
                            <ul className={styles.subNav}>
                              <For each="subItem" of={subItems}>
                                <With
                                  subItemRestrictUserRole={
                                    subItem?.restrictUserRole ?? navigationLinks(navigationLinkVariables)[subItem]?.restrictUserRole
                                  }
                                  subItemTo={subItem?.to ?? navigationLinks(navigationLinkVariables)[subItem]?.to}
                                  subItemHref={subItem.href ?? navigationLinks(navigationLinkVariables)[subItem]?.href}
                                  subItemIsActive={
                                    subItem.isActive ? subItem.isActive : navigationLinks(navigationLinkVariables)[subItem].isActive
                                  }
                                  subItemCloseMobileNav={
                                    subItem.closeMobileNav ?? navigationLinks(navigationLinkVariables)[subItem]?.closeMobileNav
                                  }
                                  subItemLabel={subItem.label ?? navigationLinks(navigationLinkVariables)[subItem].label}>
                                  <If condition={subItemRestrictUserRole !== userRole}>
                                    <li key={subItem.value || subItem}>
                                      <NavigationLink
                                        to={subItemTo}
                                        href={subItemHref}
                                        className={styles.subLink}
                                        activeClassName={styles.activeSubLink}
                                        isActive={subItemIsActive}
                                        toggleNavbar={() => subItemTo && setNavOpen(false)}>
                                        <span>{subItemLabel}</span>
                                      </NavigationLink>
                                    </li>
                                  </If>
                                </With>
                              </For>
                            </ul>
                          </If>
                        </When>
                        <Otherwise>
                          <button type="button" tabIndex="0" onClick={signOut} className={cx(styles.link, styles.buttonLink)}>
                            <AccessibleIcon icon={icon} className={styles.icon} size={18} color={colors.white} />
                            <span>{label}</span>
                          </button>
                        </Otherwise>
                      </Choose>
                    </li>
                  </If>
                </With>
              </For>
            </ul>
          </div>
        )}
      </Transition>
    </>
  )
}

export default MobileNav
